import { Api } from '../../providers/api';
import { Booking } from '../../entities/booking';
import { Component } from '@angular/core';
import { CreateBookingPage } from '../../pages/bookings/my-bookings/create-booking/create-booking';
import { MyBookingsPage } from '../../pages/bookings/my-bookings/my-bookings';
import { AlertController, NavController } from 'ionic-angular';
import { Port } from '../../entities/port';
import { RouteDestinationListPage } from '../../pages/route-destination-list/route-destination-list';
import { SearchableItem, SearchPage } from '../../pages/search/search';
import { SpinnerDialog } from '@ionic-native/spinner-dialog';
import { Shared } from '../../providers/shared';

@Component({
    selector: 'tabbed-ui',
    templateUrl: 'tabbed-ui.html'
})
export class TabbedUiComponent {

    ports: Port[] = [];
    port: Port;

    constructor(
        private alertCtrl: AlertController,
        private api: Api,
        private navCtrl: NavController,
        private spinner: SpinnerDialog,
    ) {
    }

    async loadRouteInfo() {
        this.spinner.show();
        this.ports = await this.api.getAllPorts();
        let items: SearchableItem[] = Shared.convertPortsToSearchableItems(this.ports);
        this.spinner.hide();

        this.navCtrl.push(SearchPage, {
            placeholder: 'Port name',
            items: items,
            done: (item: SearchableItem) => {
                this.port = Shared.convertItemToPort(item, this.ports);
                this.loadRouteDestinationListPage();
            },
            query: (query) => {},
            message: 'Search a port to view route info',
            title: 'Route Information',
        });
    }

    async loadBookTrip() {
        this.spinner.show();
        this.navCtrl.push(CreateBookingPage);
        this.spinner.hide();
    }

    async loadMyBookings() {
        this.spinner.show();
        let bookings: Booking[] = await this.api.getMyBookings();
        this.navCtrl.push(MyBookingsPage, {bookings: bookings});
        this.spinner.hide();
    }

    async loadRouteDestinationListPage() {
        this.spinner.show();
        let routes = await this.api.getAllRoutesForPort(this.port);
        this.spinner.hide();
        if (routes.length > 0) {
            this.navCtrl.push(RouteDestinationListPage, {
                port: this.port,
                routes: routes,
            });
            return;
        }
        let alert = this.alertCtrl.create({
            title: 'Ports',
            subTitle: 'There are no destination ports for <b>' + this.port.name + '</b>.',
            buttons: ['Dismiss']
        });
        alert.present();

    }

}



// WEBPACK FOOTER //
// ./src/components/tabbed-ui/tabbed-ui.ts